const R = (n: number) => Math.round(n * 10000) / 10000

export function oklch(l: number, c: number, h: number, alpha?: number): string {
  if (Number.isNaN(l) || Number.isNaN(c) || Number.isNaN(h))
    return "oklch(0.5 0 0)"
  if (alpha !== undefined && alpha < 1) {
    return `oklch(${R(l)} ${R(c)} ${R(h)} / ${Math.round(alpha * 100)}%)`
  }
  return `oklch(${R(l)} ${R(c)} ${R(h)})`
}
